import React from 'react';
import { MEDIUM_BLUE } from 'constants/colors';
import ReactECharts from 'components/ThemedECharts';
import { applyChartSubtitle } from 'helper/Meteorology/Agro/chartSubtitle';
import formatRainTemperatureTooltip, { formatRainTemperatureAxisPointer } from 'helper/Meteorology/Agro/rainTemperatureTooltip';
import { SequentialGraphData } from 'types/Meteorology/Agro/WaterBalanceSequential/DetailedView/getGraph';
import { getDataZoomConfig, getXAxisConfig } from 'components/Meteorology/Agro/WaterBalanceShared/chartConfig';
import ChartContainer from './ChartContainer';

interface CombinedChartProps {
  zoomStart: number;
  zoomEnd: number;
  chuva: SequentialGraphData;
  temperatura: SequentialGraphData;
  height?: string;
  hideTitle?: boolean;
  hideDataZoom?: boolean;
  /** Partes do subtítulo (Local, Período, Data da rodada); ver `buildChartSubtitle`. */
  subtitle?: string[];
}

export default function CombinedChart({
  zoomStart,
  zoomEnd,
  chuva,
  temperatura,
  height = '30rem',
  hideTitle = false,
  hideDataZoom = false,
  subtitle = [],
}: CombinedChartProps) {
  return (
    <ChartContainer height={height}>
      <ReactECharts
        className="h-100"
        option={applyChartSubtitle({
          title: hideTitle ? undefined : {
            text: 'Chuva e Temperatura',
            left: 'center',
            top: 0,
          },
          legend: hideTitle ? undefined : {
            data: ['Chuva (mm)', 'Temperatura (°C)'],
            top: 30,
            left: 'center',
            itemGap: 20,
            itemWidth: 25,
            itemHeight: 14,
            textStyle: {
              fontSize: 12,
            },
          },
          xAxis: getXAxisConfig(),
          yAxis: [
            {
              type: 'value',
              position: 'left',
              axisLabel: {
                formatter: '{value} mm',
              },
            },
            {
              type: 'value',
              position: 'right',
              axisLabel: {
                formatter: '{value} °C',
              },

            },
          ],
          series: [
            {
              name: 'Chuva (mm)',
              data: chuva.data.map((point) => ({
                name: point.date,
                value: [point.date, point.value],
              })),
              type: 'bar',
              yAxisIndex: 0,
              itemStyle: {
                color: MEDIUM_BLUE, // tema: cor de dado
              },
            },
            {
              name: 'Temperatura (°C)',
              data: temperatura.data.map((point) => ({
                name: point.date,
                value: [point.date, point.value],
              })),
              type: 'line',
              yAxisIndex: 1,
              smooth: true,
              itemStyle: {
                color: '#006400', // tema: cor de dado
              },
              lineStyle: {
                color: '#006400', // tema: cor de dado
                width: 2,
              },
            },
          ],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                formatter: formatRainTemperatureAxisPointer,
              },
            },
            formatter: formatRainTemperatureTooltip,
          },
          dataZoom: getDataZoomConfig(zoomStart, zoomEnd, [0, 1], hideDataZoom),
          animation: false,
        }, subtitle)}
      />
    </ChartContainer>
  );
}
